/*
 * TODO: Copy-n-paste from `apps/publisher/javascripts/actions/omniauth.js`
 */

import { httpRequest } from '@calendly/http-tools'
import { showHttpError } from '@calendly/alert'

import { redirectTo } from 'actions/core'

export const redirectToAuthorizeUrl = (path, sendStatistics = () => {}) => (
  async (dispatch) => {
    const [success, data] = await httpRequest({
      method: 'POST',
      url: path
    })

    sendStatistics()

    if (success) {
      dispatch(redirectTo(data.url))
    } else {
      dispatch(showHttpError(data))
    }
  }
)
